<template>
  <section class="home" id="home">
    <!-- Animated background -->
    <div class="home-background">
      <canvas id="fintech-canvas"></canvas>
      <div class="gradient-overlay"></div>
    </div>

    <!-- Main content -->
    <div class="home-content">

      <h1 class="hero-title">
        <span class="title-line" v-for="(line, index) in titleLines" :key="index">
          {{ line }}
        </span>
      </h1>

      <!-- Nuevo título grande -->
      <h2 class="hero-brand">Invextia</h2>

      <p class="hero-subtitle">{{ $t('hero.subtitle') }}</p>

      <div class="hero-actions">
        <button class="cta-primary" @click="goContact">
          <span class="cta-text">{{ $t('hero.cta') }}</span>
          <span class="cta-arrow">→</span>
        </button>
        <button class="cta-secondary" @click="openDemoModal">
          <span class="play-icon">▶</span>
          {{ $t('hero.demo') }}
        </button>
      </div>

      <!-- KPIs/estadísticas (comentados hasta tener métricas reales)
      <div class="hero-stats">
        <div class="stat-item" v-for="stat in stats" :key="stat.label">
          <div class="stat-value" :data-value="stat.value">0</div>
          <div class="stat-label">{{ stat.label }}</div>
        </div>
      </div>
      -->
    </div>

    <!-- Floating cards animation -->
    <div class="floating-cards">
      <div class="float-card card-1">
        <div class="card-icon">📊</div>
        <div class="card-label">{{ $t('hero.cards.analytics') }}</div>
      </div>
      <div class="float-card card-2">
        <div class="card-icon">💰</div>
        <div class="card-label">{{ $t('hero.cards.savings') }}</div>
      </div>
      <div class="float-card card-3">
        <div class="card-icon">📈</div>
        <div class="card-label">{{ $t('hero.cards.investment') }}</div>
      </div>
    </div>

    <!-- Video Demo Modal -->
    <Teleport to="body">
      <Transition name="modal-fade">
        <div v-if="isDemoModalOpen" class="demo-modal-overlay" @click="closeDemoModal">
          <div class="demo-modal-content" @click.stop>
            <button class="demo-modal-close" @click="closeDemoModal" aria-label="Close">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <line x1="18" y1="6" x2="6" y2="18"></line>
                <line x1="6" y1="6" x2="18" y2="18"></line>
              </svg>
            </button>
            <div class="video-wrapper">
              <video 
                ref="demoVideo"
                class="demo-video"
                controls
                preload="metadata"
                :poster="videoPoster"
              >
                <source :src="videoSource" type="video/mp4">
                {{ $t('hero.videoNotSupported', 'Your browser does not support the video tag.') }}
              </video>
            </div>
          </div>
        </div>
      </Transition>
    </Teleport>
  </section>
</template>

<script>
import { initFintechAnimation } from '@/homeAnimations.js';
import '@/styles/Home-Section.css';
import sr from '@/scrollreveal.js';

export default {
  name: 'HomeSection',
  data() {
    return {
      isDemoModalOpen: false,
      // Update these paths to match your video file location
      videoSource: require('@/assets/demo_video.mp4'), // Adjust path to your video
      videoPoster: null // Optional: add a poster image path if you have one
      // KPIs desactivados temporalmente:
      // stats: [
      //   { value: 10000, label: this.$t('hero.stats.users'), current: 0 },
      //   { value: 95, label: this.$t('hero.stats.satisfaction'), current: 0 },
      //   { value: 2500000, label: this.$t('hero.stats.managed'), current: 0 }
      // ]
    };
  },
  computed: {
    titleLines() {
      return this.$t('hero.title').split('\n');
    }
  },
  mounted() {
    // Initialize animations
    sr.reveal('.hero-badge', { delay: 100 });
    sr.reveal('.hero-title .title-line', { interval: 100, delay: 200 });
    sr.reveal('.hero-subtitle', { delay: 400 });
    sr.reveal('.hero-actions', { delay: 500 });
    // sr.reveal('.hero-stats', { delay: 600 }); // desactivado (stats ocultos)
    sr.reveal('.floating-cards .float-card', { interval: 100, delay: 700 });

    // Start canvas animation
    this._disposeAnim = initFintechAnimation('fintech-canvas');

    // Add escape key listener for modal
    this.handleEscKey = (e) => {
      if (e.key === 'Escape' && this.isDemoModalOpen) {
        this.closeDemoModal();
      }
    };
    document.addEventListener('keydown', this.handleEscKey);

    // Animate stats counter (desactivado)
    // this.animateStats();
  },
  beforeUnmount() {
    if (this._disposeAnim) this._disposeAnim();
    document.removeEventListener('keydown', this.handleEscKey);
  },
  methods: {
    goContact() {
      const target = document.querySelector('#contact');
      if (target) target.scrollIntoView({ behavior: 'smooth' });
    },
    
    openDemoModal() {
      this.isDemoModalOpen = true;
      // Prevent body scroll when modal is open
      document.body.style.overflow = 'hidden';
      
      // Auto-play video when modal opens (optional)
      this.$nextTick(() => {
        if (this.$refs.demoVideo) {
          this.$refs.demoVideo.play().catch(err => {
            // Handle autoplay policy restrictions
            console.log('Autoplay prevented:', err);
          });
        }
      });
    },
    
    closeDemoModal() {
      this.isDemoModalOpen = false;
      // Restore body scroll
      document.body.style.overflow = '';
      
      // Pause video when closing
      if (this.$refs.demoVideo) {
        this.$refs.demoVideo.pause();
      }
    },
    
    // Keep the old learnMore method as fallback
    learnMore() {
      // Now opens the demo modal instead of scrolling
      this.openDemoModal();
    },

    // Lógica de KPIs desactivada temporalmente:
    // animateStats() { … }
    // countUpStats() { … }
  }
};
</script>

<style src="@/styles/Home-Section.css"></style>
